// pages/UserAdmin/crm/SilenceBadge.js
//
// Badge inline "N dias sem resposta". Aparece na row do contato quando
// o backend devolve `days_since_last_inbound >= SILENCE_THRESHOLD_DAYS`.
//
// Filtro adicional aplicado no componente (não no backend): só destaca
// contatos que estão em `PENDENTE` de reunião OU com interesse
// ALTO/MEDIO — silêncio de contato "FRIO" ou "NAO_AGENDADA" é ruído,
// não sinal.
//
// Out/26: contato SEM classificação também conta. Enquanto todo contato
// nascia "MEDIO" por default do banco, os não classificados já caíam no
// ALTO/MEDIO e ganhavam badge. Ao tornar a ausência um estado real (NULL),
// eles sairiam do filtro justamente ao virar fila de triagem — sumir com o
// alerta de quem ninguém olhou E não responde há dias é o oposto do que o
// badge existe pra fazer. "Não classificado" é desconhecido, não frio.

import { Box, Tooltip } from '@mui/material';
import { CRM_THEME, SILENCE_THRESHOLD_DAYS } from './theme';
import { Icon } from './icons';

const RELEVANT_MEETING = new Set(['PENDENTE']);
const RELEVANT_INTEREST = new Set(['ALTO', 'MEDIO']);

// Duas representações da mesma coisa chegam aqui: `null`, que é o que o
// backend serializa, e a string sentinela, que a lista carrega por alguns
// instantes durante o update otimista (antes do refetch confirmar).
export function isUnclassified(contact) {
  return !contact?.interest_status || contact.interest_status === 'NAO_CLASSIFICADO';
}

export function isSilent(contact) {
  if (contact?.days_since_last_inbound == null) return false;
  if (contact.days_since_last_inbound < SILENCE_THRESHOLD_DAYS) return false;
  return (
    isUnclassified(contact) ||
    RELEVANT_MEETING.has(contact.meeting_status) ||
    RELEVANT_INTEREST.has(contact.interest_status)
  );
}

export default function SilenceBadge({ days, alto = 24 }) {
  const s = CRM_THEME.silence;
  // Pílula âmbar do design novo (out/26): mesma altura dos outros selos da
  // linha, pra Situação e Interesse ficarem alinhados.
  return (
    <Tooltip title={`Sem resposta há ${days} dias — considere reengajar`} arrow>
      <Box
        component="span"
        sx={{
          display: 'inline-flex', alignItems: 'center', gap: '5px',
          height: alto, px: '9px', borderRadius: '999px',
          fontFamily: CRM_THEME.font.ui, fontSize: alto > 24 ? 13 : 12, fontWeight: 600,
          bgcolor: s.bg, color: s.color, border: `1px solid ${s.border}`,
          whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums',
        }}
      >
        <Icon.Clock size={12} strokeWidth={2.2} />
        {days}d sem resposta
      </Box>
    </Tooltip>
  );
}
